import React from "react";
import { Grid, Typography } from "@mui/material";
import "../../assets/css/icon.css";

const PopupError = ({ closePopupError, copyError }) => {
  return (
    <Grid container style={{ backgroundColor: "#fff" }}>
      <Grid item xs={12} style={{ display: "flex", alignItems: "center" }}>
        <Grid xs={1} item>
          {" "}
          <div className="icon-error-message" />
        </Grid>
        <Grid xs={10} item>
          {" "}
          <Typography
            className="color-primary-dark"
            style={{ marginLeft: "20px" }}
          >
            {copyError}
          </Typography>
        </Grid>
        <Grid xs={1} item>
          {" "}
          <div
            className="icon-remove-file"
            style={{ marginLeft: "10px" }}
            onClick={(e) => {
              closePopupError();
            }}
          ></div>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PopupError;
